import { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { updateElementIfNotDeleted } from '../../../../actions/elementActions';

export const useImageModalCaptionHideOnClose = (elementId: string) => {
    const dispatch = useDispatch();
    const elementIdsToHideRef = useRef(new Set<string>());

    const setCaptionHiddenOnClose = useCallback(
        (hidden: boolean) => {
            if (hidden) {
                elementIdsToHideRef.current.add(elementId);
            } else {
                elementIdsToHideRef.current.delete(elementId);
            }
        },
        [elementId],
    );

    useEffect(
        () => () => {
            elementIdsToHideRef.current.forEach((id) => {
                dispatch(updateElementIfNotDeleted({ id, changes: { showCaption: false } }));
            });
        },
        [dispatch],
    );

    return setCaptionHiddenOnClose;
};
